export const FLAGS = {
  SAMPLE_FEATURE: 'sample-feature',
  ENABLE_CLERK_CONSOLE_STREAMING_CONTROLS: 'enable-clerk-console-streaming-controls',
  ENABLE_PDF_PREFLIGHT: 'enable-pdf-preflight',
  ENABLE_SEQUENTIAL_MEETING_STREAMING: 'enable-sequential-meeting-streaming',
  MEETING_SCRIPTS: 'meeting-scripts',
};
